module.exports = "/images/img_06_sp.png?50930173b823c8fdbd63174e5b2afe89";